import { Fragment, useMemo } from "react";
import "./Stepper.css";

export const Stepper = ({ steps, currentStep, recentFirst, item, navigateToOtherStep}) => {
  const startsFrom_ = recentFirst ? "bottom" : "top";
  const completedTo = (currentStep ?? steps?.length) - 1;
  const steps_ = useMemo(() => {
    return startsFrom_ === "top" ? steps : steps.toReversed();
  }, [steps]);
  const isStepRemaining = (index) =>
    startsFrom_ === "top"
      ? index > completedTo
      : index < steps_.length - 1 - completedTo;

  return (
    <div className="stepper-component">
      {steps_?.map((step, key) => (
        <Fragment key={key}>
          <div className={`${"step-indicator"}`}>
            <div className={`step-connector ${key === 0 ? "hide" : ""}`}>
              <div></div>
            </div>
            <div
              className={`circle-stepicon ${
                step.transactionType == "IN" ? "green-step" : "red-step"
              }`}
            >
              <i
                style={step.iconStyle}
                className={step.icon ?? "icon-windows"}
              ></i>
            </div>
            <div
              className={`step-connector ${
                key === steps_.length - 1 ? "hide" : ""
              }`}
            >
              <div></div>
            </div>
          </div>
          <div className="steper-card-info">
            <div
              className={`step-name ${
                step.transactionType == "IN" ? "green-name" : "red-name"
              }`}
            >
              <span>{step.name}</span>
              <p onClick={() => navigateToOtherStep(step)} className="step-name">
                {step.transactionType == "OUT"
                  ? (step.destinationBatchName  && (step.destinationBatchName != item.Batch))
                    ? "New Batch " + step.destinationBatchName
                    : ""
                  : ""}
                {step.transactionType == "IN"
                  ? (step.originalBatchName && (step.originalBatchName != item.Batch))
                    ? "From Batch " + step.originalBatchName
                    : ""
                  : ""}
              </p>
            </div>
            <div className="steper-location">
              {step.transactionType === "OUT" && step.finalLocation ? (
                <>
                  <span>From: </span> <b>{step.location ?? ""}</b>
                  <span>To: </span> <b>{step.finalLocation}</b>
                </>
              ) : step.transactionType === "IN" && step.originalLocation ? (
                <>
                  <span>From: </span> <b>{step.originalLocation}</b>
                  <span>To: </span> <b>{step.location ?? ""}</b>
                </>
              ) : (
                <>
                  <span>Location: </span>
                  <b>{step.location ?? ""}</b>
                </>
              )}
            </div>

            <div className="steper-quanity">
              <b>{step.quantity + " " + item.uomName}</b>
              <span>{step.transactionDate ?? ""}</span>
            </div>
          </div>
        </Fragment>
      ))}

      {/* </div> */}
    </div>
  );
};
